import { MondayLogo } from "frontend/icons/monday-logo";
import React from "react";
import { Html } from "react-konva-utils";
import styles from "./connector-popup.module.css";
import { CloseIcon } from "frontend/icons/close";

type ConnectorPopupProps = {
  x?: number;
  y?: number;
  onChange: (value: "monday" | "custom") => void;
  onClose: () => void;
};

export const ConnectorPopup = ({ x, y, onChange, onClose }: ConnectorPopupProps) => {
  if (!x || !y) {
    return null;
  }

  return (
    <Html
      groupProps={{ x: x, y: y }}
      divProps={{
        position: "relative",
      }}
    >
      <div className={styles.closeIcon}>
        <CloseIcon onClick={onClose} />
      </div>

      <div
        className={styles.wrapper}
        onChange={(e) => onChange((e.target as HTMLInputElement).value as "monday" | "custom")}
      >
        <div className={styles.header}>
          <h3 className={styles.title}>Set dependency type</h3>
        </div>
        <div className={styles.option}>
          <input type="radio" name="connectorType" id="monday" value={"monday"} />
          <label className={styles.mondayIcon} htmlFor="monday">
            Integrate with <MondayLogo width={18} hanging={10} /> column
          </label>
        </div>
        <div className={styles.option}>
          <input
            type="radio"
            name="connectorType"
            id="custom"
            defaultChecked
            value={"custom"}
            onClick={(e) => {
              if (e.currentTarget.checked) {
                onChange("custom");
              }
            }}
          />
          <label htmlFor="custom">No integration</label>
        </div>
      </div>
    </Html>
  );
};
